import { BordButton, BordOneToneIcon } from 'bord-design-system';
import { QRCodeSVG } from 'qrcode.react';

import './SessionActiveQR.scss';

interface ISessionActiveQRProps {
  qrUrl: string;
  timeLeft: number;
  isDisabled?: boolean;
  onRegenerateQr: () => void;
}

const SessionActiveQR = ({ qrUrl, timeLeft, isDisabled, onRegenerateQr }: ISessionActiveQRProps) => {
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const isExpiringSoon = timeLeft < 60;

  /**
   * Abre en una nueva pestaña la URL de evidencia asociada al código QR activo.
   */
  const handleUploadFromPc = () => {
    window.open(qrUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`sessionActiveQrContainer ${isDisabled ? 'interactionDisabled' : ''}`}>
      <div className="qrLayout">
        <div className="qrWrapper">
          <QRCodeSVG value={qrUrl} size={101} className="qrSvg" title="Código QR de evidencia activo" />
        </div>

        <div className="qrContent">
          <div className="qrTitleRow">
            <BordOneToneIcon variant="camera" standardSize={16} stroke="#070f21" />
            <p className="qrTitle">Escanea este código QR</p>
          </div>

          <p className="qrSubtitle">
            Accede con tu teléfono para subir fotos del estado de la herramienta. <br /> El enlace se reiniciará en:{' '}
            <span className={`qrTimer ${isExpiringSoon ? 'qrTimerCritical' : ''}`}>{formatTime(timeLeft)} min</span>
          </p>
          <div className="qrActionsRow">
            <BordButton
              label="Generar nuevo código QR"
              bordButtonStyle="outlined"
              onClick={onRegenerateQr}
              disabled={isDisabled}
              customClassName="sessionActiveQrActionButton"
            />
            <BordButton
              label="Subir fotos (PC)"
              bordButtonStyle="outlined"
              onClick={handleUploadFromPc}
              disabled={Boolean(isDisabled || !qrUrl)}
              customClassName="sessionActiveQrActionButton"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionActiveQR;
